import React from "react";
import "./static/css/pluggins/bootstrap.min.css"; /* == animate Headline == */
import "./static/css/pluggins/animate.css"; /* == et-line icon font == */
//import "./static/css/pluggins/et-line.css"; /* == icofont icon font == */
//import "./static/css/pluggins/icofont.css"; /* == fontawesome icon font == */
//import "./static/css/pluggins/fontawesome-all.min.css"; /* == magnific-popup == */
import "./static/css/pluggins/magnific-popup.css"; /* == owl.carousel == */
//import "./static/css/pluggins/owl.carousel.min.css";
import "./static/css/pluggins/owl.theme.default.min.css"; /* == helper classes == */
import "./static/css/pluggins/helper.css"; /* == contact form classes == */
import "./static/css/pluggins/mailform.css";
import "./App.css";
import Preloader from "./components/preloader";
import Footer from "./components/footer";
import Header from "./components/header";
import About from "./components/about";
import Experience from "./components/experience";
import Contact from "./components/contact";
import store from "./store/index";
import { Provider } from "react-redux";

function App() {
  return (
    <Provider store={store}>
      <div className="App sidebar-menu">
        <Preloader />
        <Header />
        <About />
        <Experience />
        <Contact />
        <Footer />
      </div>
    </Provider>
  );
}

export default App;
